
<p-card>
    <p-header class="title">{{TITLE}}</p-header>
    <div class="scrollable-content content">
        <a class="map-link" href="https://www.bing.com/maps/?v=2&where1=48.671%2c10.371">{{LROUTE}}</a>
        <div class="map" id="map" style="position:relative; width:800px; height:800px;margin:15px auto">
        </div>
    </div>
</p-card>